import { media } from '@anm/styles/helpers';
import styled from 'styled-components';

const hideOnTablet = media.tablet`
    display: none !important;
`;
const HideOnMobile = styled.div`
  white-space: nowrap;
  ${hideOnTablet};
`;

export default HideOnMobile;
